/* OSJET Design-Ebene, Unterseiten: setzt nur Darstellungs-Klassen; Texte, Überschriften und Reihenfolge bleiben unverändert.
   - Absatz, der nur aus einem Link besteht, wird als Button dargestellt.
   - Unter „Häufige Fragen …“ werden Frage (h3) und Antwort als Karte dargestellt, ebenso reine
     Paare aus Zwischenüberschrift und einem Absatz (z. B. Vorteile). */
(function () {
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };
  each(document.querySelectorAll('#main .page-content.rte, #main .werkstoff__beschreibung'), function (rte) {
    each(rte.children, function (p) {
      if (p.tagName !== 'P' || p.children.length !== 1 || p.firstElementChild.tagName !== 'A') return;
      var a = p.firstElementChild;
      if (a.querySelector('img') || p.textContent.trim() !== a.textContent.trim()) return;
      p.classList.add('osj-cta');
      a.classList.add('button', 'button--primary');
    });
    each(rte.children, function (h2) {
      if (h2.tagName !== 'H2') return;
      var faq = /häufige fragen|faq/i.test(h2.textContent);
      var el = h2.nextElementSibling, groups = [];
      while (el && el.tagName === 'H3') {
        var g = { q: el, a: [] };
        el = el.nextElementSibling;
        while (el && !/^(H1|H2|H3|HR)$/.test(el.tagName)) { g.a.push(el); el = el.nextElementSibling; }
        groups.push(g);
      }
      if (groups.length && groups[groups.length - 1].a.length > 1) groups[groups.length - 1].a.length = 1;
      if (!faq && (groups.length < 2 || groups.some(function (g) { return g.a.length !== 1; }))) return;
      groups.forEach(function (g) {
        if (!g.a.length) return;
        g.q.classList.add('osj-q');
        if (!faq) g.q.classList.add('osj-q--punkt');
        g.a.forEach(function (x) { x.classList.add('osj-a'); });
        g.a[g.a.length - 1].classList.add('osj-a-end');
      });
    });
  });
})();

/* OSJET Design-Ebene: Inhalte beim Scrollen sanft einblenden.
   Bereits sichtbare Inhalte bleiben unberührt; ohne JavaScript oder bei reduzierter Bewegung ist alles sofort sichtbar.
   Neben dem IntersectionObserver prüft ein Scroll-Abgleich, damit beim schnellen Scrollen nichts unsichtbar bleibt. */
(function () {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var sel = '[id$="__seo_leistungen"] .content-box > ul > li, [id$="__seo_technik"] tr, [id$="__seo_bestellung"] .content-box > ol > li, ' +
            '[id$="__seo_warum"] .container, [id$="__seo_region"] .content-box, [id$="__seo_faq"] .faq__item, #main .section__header, #main .content-box > .heading';
  var pending = [];
  function show(el) { el.classList.add('is-in'); var i = pending.indexOf(el); if (i > -1) pending.splice(i, 1); io.unobserve(el); }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) show(e.target); });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
  Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) {
    if (el.getBoundingClientRect().top < window.innerHeight) return;
    var i = el.parentNode ? Array.prototype.indexOf.call(el.parentNode.children, el) : 0;
    el.style.transitionDelay = Math.min(i, 5) * 70 + 'ms';
    el.classList.add('osj-r');
    pending.push(el);
    io.observe(el);
  });
  var ticking = false;
  function check() {
    ticking = false;
    var limit = window.innerHeight * 0.96;
    pending.slice().forEach(function (el) { if (el.getBoundingClientRect().top < limit) show(el); });
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; setTimeout(check, 60); } }, { passive: true });
  window.addEventListener('load', check);
})();
